import { styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';

export const PublicRoleCont = styled('div')<Theme, { shared: number }>(({ theme, shared }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 20,
  borderTop: `1px solid ${COLORS.LIGHT_BORDER}`,
  paddingTop: 40,
  border: shared ? `2px solid ${COLORS.PRIMARY} !important` : 'none',
  borderRadius: shared ? 8 : 0,
  padding: 20,
  position: 'relative',
}));

export const SharedCont = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 20,
  position: 'absolute',
  top: 0,
  left: 0,
  backgroundColor: COLORS.PRIMARY,
  padding: '5px 20px',
  borderRadius: '0 0 8px 0',
}));

export const RoleHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
}));

export const ButtonCont = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 10,
}));

export const RoleTitle = styled(CustomTypography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 500,
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.BLACK,
}));

export const InfoWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const Description = styled(CustomTypography)(({ theme }) => ({
  color: theme.palette.type === 'dark' ? COLORS.WHITE : COLORS.MAIN_GRAY,
  fontSize: 14,
  whiteSpace: 'break-spaces',
}));

export const Label = styled(CustomTypography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
}));

export const GridWrapper = styled('div')(({ theme }) => ({
  gap: 25,
  display: 'flex',
  alignItems: 'start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column-reverse',
  },
}));

export const MediaCont = styled('div')(({ theme }) => ({
  minWidth: 240,
  maxWidth: 240,
  gap: 10,
  display: 'flex',
  flexWrap: 'wrap',
  maxHeight: 500,
  overflowY: 'auto',
  [theme.breakpoints.down('sm')]: {
    minWidth: '100%',
    maxWidth: '100%',
  },
}));

export const MediaWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));

export const ContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: 20,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));
